module.exports = __webpack_public_path__ + "img/forest.6c5d4f2f.jpeg";